import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {
  citizenGetServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.actions';
import {
  CitizensServicesAutomationDetails
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.model';
import {
  selectModifiedCitizenServicesAutomation
} from 'src/app/store/entities/citizens/citizens-services-automation-details/citizens-services-automation-details.selectors';
import {AppState} from 'src/app/store/reducers';

@Component({
  selector: 'app-citizen-services-automation-details',
  templateUrl: './citizen-services-automation-details.component.html',
  styleUrls: ['./citizen-services-automation-details.component.scss']
})
export class CitizenServicesAutomationDetailsComponent implements OnInit {


  @Input() serviceUniqueId: string;
  serviceAutomationDetails$:Observable<CitizensServicesAutomationDetails []>
  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {

  }

  ngOnInit(): void {
    this.store.dispatch(citizenGetServicesAutomationDetails({filtering:{serviceUniqueId:this.serviceUniqueId}}));
    this.serviceAutomationDetails$ = this.store.select(selectModifiedCitizenServicesAutomation);
  }


}
